import React, { useState } from 'react';
import { Button } from 'antd';
import { ExportSheetProps } from '../../@types/data/types';
import { useTheme } from '../../providers/theme';
import { getColors } from '../utils/getColors';

const ExportSheet: React.FC<ExportSheetProps> = ({
  chartData,
  liaoData,
  fileName,
  xAxis,
  yAxis
}) => {
  const [exporting, setExporting] = useState(false);

  const exportToExcel = async () => {
    if (exporting) return;
    setExporting(true);
    try {
      const XLSX = await import('xlsx');
      const chartWsData = chartData
        ? [
            ['Sample Code', xAxis, yAxis],
            ...chartData.map(point => [point.sampleCode, point.x, point.y])
          ]
        : [];

      const liaoWsData = liaoData
        ? [
            [`${xAxis} [Liao Model]`, `${yAxis} [Liao Model]`],
            ...liaoData.map(point => [point.x, point.y])
          ]
        : [];

      const maxRows = Math.max(chartWsData.length, liaoWsData.length);

      const filledLiaoWsData = liaoWsData.concat(
        Array(maxRows - liaoWsData.length).fill([])
      );

      const combinedWsData = chartWsData.map((row, index) => [
        ...row,
        ...(filledLiaoWsData[index] || [])
      ]);

      const ws = XLSX.utils.aoa_to_sheet(combinedWsData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Chart Data');

      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } finally {
      setExporting(false);
    }
  };

  const { isDay } = useTheme();
  const colors = getColors(isDay);

  return (
    <Button
      type="default"
      onClick={exportToExcel}
      loading={exporting}
      disabled={exporting}
      style={{ color: colors.text }}
    >
      Download Data
    </Button>
  );
};

export default ExportSheet;
